// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dJ-z","twoColumnImage":"eJ-z"};